import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile-community',
  templateUrl: './user-profile-community.component.html',
  styleUrls: ['./user-profile-community.component.css']
})
export class UserProfileCommunityComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
